import { useMemo } from 'react';

import dayjs from 'dayjs';

import { formatMetricValue } from '@/shared/lib/utils';
import { DonutChart } from '@/shared/ui/DonutChart';
import { Icon } from '@/shared/ui/Icon';

import { DATA_ZONE_COLOR_MAP, DATA_ZONE_ORDER, useDataZoneRowCountQuery } from '@/entities/quality';

import { CardHeader } from '@/features/quality/ui/dashboard/CardHeader';
import { CardRightContent } from '@/features/quality/ui/dashboard/CardRightContent';
import { DonutLabelList } from '@/features/quality/ui/dashboard/DonutLabelList';

import styles from './DataZoneCountArticle.module.css';

const TITLE = '데이터 존별 수집 현황';

export const DataZoneCountArticle = () => {
  const yesterdayDate = dayjs().subtract(1, 'day').format('YYYY-MM-DD');

  const { data: apiResponse, isLoading: showLoading } = useDataZoneRowCountQuery({
    fromDate: yesterdayDate,
    toDate: yesterdayDate,
    countType: 'total',
  });

  const chartData = useMemo(() => {
    if (!apiResponse?.summary) {
      return DATA_ZONE_ORDER.map((zone) => ({ name: zone, value: 0 }));
    }

    const { summary } = apiResponse;
    return DATA_ZONE_ORDER.map((zone) => ({
      name: zone,
      value: summary[zone.toLowerCase() as keyof typeof summary]?.totalRows ?? 0,
    }));
  }, [apiResponse]);

  const labelListData = useMemo(() => {
    return chartData.map((item) => ({
      icon: <Icon name="gem" size={13.54} color={DATA_ZONE_COLOR_MAP[item.name as keyof typeof DATA_ZONE_COLOR_MAP]} />,
      label: item.name,
      value: formatMetricValue(item.value),
    }));
  }, [chartData]);

  return (
    <>
      <CardHeader title={TITLE} rightContent={<CardRightContent dateRangeText={yesterdayDate} />} />
      <DonutChart
        data={chartData}
        showLoading={showLoading}
        isTotalVisible={true}
        isLegendVisible={false}
        colorMap={DATA_ZONE_COLOR_MAP}
        containerClassName={styles.chartContainer}
        style={{ width: '200px', height: '200px' }}
      />
      <DonutLabelList items={labelListData} />
    </>
  );
};
